import { InputProps } from "@campgladiator/cgui-core.atoms.input";
import {
  ItemProps,
  ListMenuProps,
} from "@campgladiator/cgui-core.molecules.list-menu";

type FormatClickableMenuItemArgs = {
  trainer: ItemProps;
} & SharedTrainerItemsArgs;

type GetTrainerItemsArgs = {
  filteredPredictions: ItemProps[];
} & SharedTrainerItemsArgs;

type SharedTrainerItemsArgs = {
  setFilteredTrainers: (items: ListMenuProps["items"]) => void;
  setUserInput: (input: string) => void;
  setShowList: (show: boolean) => void;
  handleOnOptionSelect: (trainer: ItemProps) => void;
};

const formatClickableMenuItem = (args: FormatClickableMenuItemArgs) => {
  const {
    trainer,
    setFilteredTrainers,
    setUserInput,
    setShowList,
    handleOnOptionSelect,
  } = args;
  return {
    ...trainer,
    handleClick: () => {
      setFilteredTrainers([]);
      setUserInput(trainer.text || "");
      setShowList(false);
      handleOnOptionSelect(trainer as ItemProps);
    },
  };
};

export const getTrainerItems = (args: GetTrainerItemsArgs) => {
  const { filteredPredictions } = args;
  const items = filteredPredictions.map((trainer) =>
    formatClickableMenuItem({
      ...args,
      trainer,
    })
  );

  const itemsWithLabel = [
    {
      type: "header",
      text: "AVAILABLE TRAINERS",
      itemId: "0",
    },
    ...items,
  ];
  return itemsWithLabel;
};

export const getSearchBarIcon = (userInput: string): InputProps["icon"] =>
  userInput?.length === 0
    ? { type: "solid", name: "icon-search" }
    : { type: "monochrome", name: "times-circle" };
